import React from "react";
import TextTable from "../../components/tables/TextTable";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { SYSTEM_LANGUAGE_LABELS } from "../../shared/enums/shared-enums";
import { Text } from "../../types/text";

interface MainTextPageProps {
  systemLanguageType: Text["system_language_type"];
}

const MainTextPage: React.FC<MainTextPageProps> = ({ systemLanguageType }) => {
  const navigate = useNavigate();
  const languageLabel = SYSTEM_LANGUAGE_LABELS[systemLanguageType];

  return (
    <Box>
      <Box
        sx={{
          mb: 4,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{
            position: "absolute",
            left: 16,
          }}
          startIcon={<AddIcon />}
          onClick={() => navigate("create")}
        >
          Create Text
        </Button>
        <Typography variant="h1">
          {languageLabel ? `${languageLabel} Texts` : "Texts"}
        </Typography>
      </Box>
      <TextTable filters={{ system_language_type: systemLanguageType }} />
    </Box>
  );
};

export default MainTextPage;
